// eslint-disable-next-line import/prefer-default-export
export const JOBS_ES = {
  // BB
  SelectCompany: 'Seleccionar plantilla de empresa',
  sharedTooltip: 'Esto migrara la vacante a la empresa que se indique.',
  addCancel: 'CANCELAR',
  addSave: 'GUARDAR',
  bigBrotherTitle: 'Big Brother HH',
  // common
  Cancel: 'Cancelar',
  Delete: 'Eliminar',
  Add: 'Agregar',
  Yes: 'Yes',
  No: 'No',
  Accept: 'Accept',

  // main Jobs
  placeholderSearch: 'Buscar: CTO',
  newJobButton: 'Nuevo trabajo',
  filterButton: 'Filtros',
  ProfileAlert: 'FAVOR DE CREAR PERFIL',
  HelpVideo: 'Video de ayuda',
  IntroductoryVideo: 'Video de introducción',

  // Notifications dashboard
  YourCalendar: 'SU CALENDARIO',
  AddEvent: 'Agregar evento',
  NoCalendar: 'Sin calendario incorporado',
  // modalEvent
  InfoEventHeader: 'Información del evento ',
  UrlCall: 'Url de la llamada: ',
  JoinMeet: 'Unirse con Google Meet',
  NoEvent: 'Sin reunión programda',
  Time: 'Hora:',
  Date: 'Fecha:',
  FieldRequired: 'Dato requerido',
  From: 'De:',
  To: 'A:',
  GoToMeet: 'Ir a Meet',

  // stepper
  Previous: 'Anterior',
  Next: 'Siguiente',
  Publish: 'Publicar',
  Vacancy: 'Vacante',
  Scope: 'Alcance',
  PayAndOrPublish: 'Pagar y/o publicar',

  // modalCreateJob
  CreateHeader: '¿Qué clase de vacante vamos a crear?',
  RegularVacancy: 'Vacante normal',
  RegularDescription:
    'Llega a candidat@s activamente buscando empleo. Publica tu vacante y filtra al mejor talento de manera inteligente.',
  Headhunting: 'Headhunting',
  OperativeVacancy: 'Vacante operativa',
  OperativeDescription:
    'Publicación sencilla en http://lapieza.io/ y otras bolsas de trabajo\n' +
    'integradas. Especialmente para perfiles de producción y servicios.',
  HuntingDescription:
    ' Obtén perfiles pasivos que corresponden exactamente con lo que buscas con nuestro partner LaPieza.io.',

  // modalMultiposting
  Publishing: 'Publicando',
  Of: 'de',
  PublishingOn: 'Publicando en:',

  // form Create new job
  // formDetails
  Name: 'Nombre',
  Type: 'Tipo',
  InOffice: 'Físico',
  Remote: 'Remoto',
  Address: 'Dirección',
  Seniority: 'Antigüedad',
  Contract: 'Contrato',
  Category: 'Categoría',
  Carrer: 'Carrera',
  campus: 'Campus',
  placeholderSelectCategories: 'Seleccione categorías',
  Wage: 'Sueldo',
  Range: 'Rango',
  Negotiable: 'Negociable',
  Minimum: 'Mínimo',
  Maximum: 'Máximo',
  RequiresCv: 'Requiere CV',
  Description: 'Descripción',
  WantConfidential: '¿Quiere que sea confidencial?',
  WantNotification: '¿Quiere que su gente sea notificada cuando alguien se postula?',
  Emails: 'Lista de correos:',
  HaventAdded: 'No ha agregado ningún correo',
  WantOwners: '¿Quiere agregar encargados?',
  Recruiter: 'Reclutador',
  User: 'Usuario',
  ColumnsTemplate: 'Seleccione una plantilla de columnas:',
  placeholderSearchTemplates: 'Buscar plantillas',
  AssignVacancysName: 'Asignar nombre de la vacante',
  UploadCustom: 'Subir imagen personalizada',
  HorizontalImg: 'La imagen debe ser preferentemente horizontal',
  // seniorities
  Intern: 'Practicante y Becario',
  Flexible: 'Flexible',
  Junior: 'Junior',
  Senior: 'Senior',
  Ejecutivo: 'Ejecutivo',
  Otro: 'Otro',
  // contract
  Freelance: 'Freelance',
  Temporal: 'Temporal',
  HalfTime: 'Medio tiempo',
  FullTime: 'Tiempo completo',
  // categories
  Administration: 'Administración',
  Banking: 'Banca',
  Law: 'Derecho',
  Development: 'Desarrollo web / TI',
  Design: 'Diseño',
  Edtech: 'Edtech',
  Finances: 'Finanzas',
  Fintech: 'Fintech',
  Healathtech: 'Healthtech',
  Humanities: 'Humanidades',
  CreativeIndustries: 'Insustrias creativas',
  Engineering: 'Ingenierías',
  Insurtech: 'Insurtech',
  Legal: 'Legal',
  Logistics: 'Logística',
  Management: 'Management',
  DigitalMarketing: 'Marketing digital',
  Fashion: 'Moda',
  OngSocial: 'ONGs/ Social, Operaciones',
  Psychology: 'Psicología',
  Proptech: 'Proptech',
  HumanResources: 'Recursos Humanos',
  Health: 'Salud',
  Insurances: 'Seguros',
  Sells: 'Ventas',
  Other: 'Otros',

  // Hard skills
  SelectHardSkills: 'Seleccione las hard skills que serán evaluadas en los postulantes',
  MaximumSkills:
    'Puede seleccionar hasta 3 hard skills. Se aplicará una prueba mínima con las habilidades seleccionadas. ',
  CustomizedQuetions: 'Agregar preguntas personalizadas',
  Optional: '(Opcional)',
  HaveToAnswer: 'Los postulantes tienen que responder estas preguntas para poder postularse.',
  AddQuestion: 'Agregar pregunta',
  UpdateQuestion: 'Actualizar pregunta',
  Question: 'Pregunta',
  QuestionType: 'Tipo de pregunta',
  OpenQuestion: 'Pregunta abierta',
  OpenShortQuestion: 'Pregunta abierta (respuesta corta)',
  OpenExtendedQuestion: 'Pregunta abierta (respuesta extensa)',
  ClosedQuestion: 'Pregunta cerrada',
  MultipleChoiceQuestion: 'Pregunta de opción multiple',
  RangeQuestion: 'Pregunta sobre rangos',
  placeholderCorrectAnswer: 'Respuesta correcta',
  placeholderTimeToAnswer: 'Tiempo para responder (segundos)',
  AddOption: 'Agregar opción',
  UpdateOption: 'Actualizar opción',
  placeholderOption: 'Opción',
  // skills
  LogMathReasoning: 'Razonamiento lógico-matemático',
  VerbalReasoning: 'Razonamiento verbal',
  English: 'Inglés',
  Marketing: 'Marketing digital ',
  Startups: 'Conocimiento de startups y levantamiento de capital',
  Mexico: 'Cultura general de México',
  Programming: 'Programación básica',

  // Alcance
  Title: '¿Sabías que es más barato publicar tus vacantes en LinkedIn a través de nuestra plataforma?',
  TitleDesc:
    'Incremente el alcance de sus vacantes publicándolas en universidades, bolsas de trabajo y plataformas especializadas.',
  JobPlatforms: 'Plataformas de trabajo:',
  Days: 'días',
  Free: 'Gratuito',
  OtherPlatforms: 'Otras plataformas gratuitas:',
  Platforms: 'Plataformas',
  InstitutionsOnEachBlock: 'Instituciones en cada bloque',
  tooltipOcc: 'Publicación sencilla de 60 días a nombre de LaPieza.io.',
  tooltipIndeed: 'Publicación de 15 días a nombre de su empresa. Ahorro promedio de 500 pesos por vacante.',
  tooltipLinkedIn30: 'Publicación de 30 días a nombre de su empresa. Ahorro promedio de 5,000 pesos por publicación.',
  tooltipLinkedIn15: 'Publicación de 15 días a nombre de su empresa. Ahorro promedio de 2,000 pesos por publicación.',
  // blocks
  Institute: 'Instituto',
  IT: 'Desarrollo web y TI',
  ITExample: '(Frontend, Fullstack, Backend, Testers)',
  engineering: 'Otras ingenierías',
  engineeringExample: '(Física, Química)',
  bussines: 'Negocios',
  bussinesExample: '(Economía, Admin, RH, MKT, Diseño)',
  humanities: 'Humanidades',
  humanitiesExample: '(Letras, Artes)',
  medicine: 'Salud',
  medicineExample: '(Medicina, Veterinaria, Dentista)',
  services: 'Operativos y servicios',
  servicesExample: '(Ejecutivos de ventas, operaciones, logística)',
  social: 'Ciencias Sociales',
  socialExample: '(Derecho, Psicología, Educación)',

  // Publish
  Use: 'Usar',
  Do: 'Realizar',
  PleaseWait: 'Espere, por favor...',
  NoPayment: 'Su publicación no requiere pago.',

  // pauseJob
  DeleteHeader: 'Pausar vacante',
  ConfirmationMessage: '¿Seguro que desea pausar esta vacante?',
  ConfirmationMessageClosed: '¿Seguro que desea carrar esta vacante?',
  WhatShouldWeDo: 'Que deberíamos hacer con los postulantes, ¿Les notificamos por email?',
  Notify: 'Notificar',
  DoNotNotify: 'No notificar',
  pause: 'Pausar',
  closed: 'Cerrar',

  // deleteJob
  choosePauseOrClosed: '¿Estás seguro de pausar la vacante o prefieres cerrar la vacante?',
  descriptionPauseOrClose: 'Si cierras la vacante, ya no podrás realizar cambios.',
  DeleteVacancy: 'Eliminar vacante',
  ConfirmationDelete: '¿Seguro que quieres eliminar esta vacante permanentemente?',
  DeleteWarning: 'Esta acción eliminará los postulantes y la vacante, esta acción no se puede revertir.',
  // modalBlocked
  BlockedHeader: 'Esta acción no se puede realizar',
  BlockedMessage:
    ' Tu plan actual no permite tener más de una vacante activa, puedes pausar la vacante activa y después\n' +
    '            volver a intentarlo o si lo prefieres puedes ponerte en contacto con nosotros: pol@lapieza.io',
  ChangePlan: 'Cambiar plan',
  Contact: 'Contactarnos',
  // modalFilters
  All: 'Todos',
  ActivePlural: 'Activas',
  PausedPlural: 'Pausadas',
  ClosedPlural: 'Cerradas',
  Predefined: 'Predefinido',
  Newer: 'Más nuevo',
  Older: 'Más viejo',
  Owners: 'Encargados',
  ShowVacancies: 'Mostrar vacantes',
  OrderBy: 'Ordenar por',
  Reset: 'Resetear',

  // Vacancies cards
  tooltipPause: 'Pausar',
  tooltipActivate: 'Activar',
  tooltipSee: 'Ver',
  tooltipShare: 'Compartir',
  tooltipEdit: 'Editar',
  tooltipAnalytics: 'Analiticas',
  tooltipDelete: 'Definitivo',
  Confidential: 'Confidencial',

  // Modal de crear evento
  newEvent: 'Nuevo evento',
  updateEvent: 'Actualizar evento',
  titleEvent: 'Título del evento',
  descriptionEvent: 'Descripción del evento',
  start: 'Inicio',
  end: 'Fin',
  addMeet: 'Agregar Meet',
  notifyGuest: 'Notificar a invitados',
  guest: 'Invitados',

  // Notifications
  OnlyNumbersAllowed: 'Solo números permitidos',
  AtLeastName: 'La vacante debe tener mínimo un nombre',
  EmailAlreadyAdded: 'Correo ya registrado',
  InvalidEmail: 'Correo inválido',
  OnlyThreeHard: 'Solo se pueden seleccionar 3 hard skills',
  PaymentRejected: 'El banco rechazó el pago, intente de nuevo o llame a su banco.',
  UrlCopied: 'URL copiada',
  StartingDeletion: 'Iniciando eliminación',
  ComingSoon: 'Disponible próximamente',
  Document: 'Documento',
  SuccessfullyDeleted: 'borrado exitosamente',

  // Modal Edit Vacancy
  EditVacancy: 'Editar Vacante',
  SaveChanges: 'Guardar cambios',
  EditSuccess: 'Cambios Guardados',
  ErrorUpdateData: 'Ocurrió un error al actualizar',
};
